import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '@env';
import {Database, get, ref} from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  headers: HttpHeaders;
  apiUrl: string;

  constructor(private http: HttpClient, private db: Database) {
    this.apiUrl = environment.apiUrl;
  }

  getUrl(url): string {
    return `${this.apiUrl}/${url}`;
  }

  async getReportCount() {
    const path = `carvryStats/reports`;
    const dbRef = ref(this.db, path);
    return (await get(dbRef)).val();
  }
}
